// Highlight visits that an assigned agent should prepare for immediately. The dashboard itself
// is the reminder surface; completed/cancelled visits never receive an active reminder.
export function visitAttention(visit, now = Date.now()) {
  if (visit.status === 'cancelled' || ['COMPLETED', 'CANCELLED'].includes(visit.returnStatus)) return '';
  if (visit.deliveryNeedsReassignment) return 'Reassignment needed';
  if (!visit.deliveryAssignment?.assignedTo) return 'Assignment needed';
  const scheduledAt = new Date(visit.deliveryAssignment.scheduledAt || visit.startDate).getTime();
  if (!Number.isFinite(scheduledAt)) return '';
  if (scheduledAt < now) return 'Visit time has passed';
  if (scheduledAt - now <= 60 * 60 * 1000) return 'Visit due within 1 hour';
  return '';
}
